import { GLOBAL } from '@lumapps/translations';

export enum WIDGET_BASE {
    /**
     * @value Remove all attachments
     */
    ATTACHMENTS_DELETE_ALL = 'FRONT.ATTACHMENTS.DELETE_ALL',
    /**
     * @value Widget could not load
     * @description Use the term "widget" in all the languages (don't translate it).
     */
    COULD_NOT_LOAD = 'FRONT.WIDGET.WIDGET_COULD_NOT_LOAD',
    /**
     * @value Widget not available in new version
     */
    NOT_MIGRATED = 'FRONT.WIDGET.WIDGET_NOT_MIGRATED',
    /**
     * @value Remove file
     */
    REMOVE_FILE = 'WIDGET_BASE.REMOVE_FILE',
    /**
     * @value {"one":"Remove image","other":"Remove images"}
     */
    REMOVE_IMAGE_PLURAL = 'WIDGET_BASE.REMOVE_IMAGE_PLURAL',
    /**
     * @value Remove video
     */
    REMOVE_VIDEO = 'FRONT.VIDEO.CONFIRM_DELETE_TITLE',
    /**
     * @value Information displayed
     * @description Title of the section on widget settings used to select the information that will be displayed
     */
    SETTINGS_INFORMATION_DISPLAYED_TITLE = 'WIDGET_BASE.SETTINGS_INFORMATION_DISPLAYED_TITLE',
    /**
     * @value Max number of item per line
     * @description Helper for widget-settings input, should warn user that the number selected will be the maximum number of columns for this widget
     */
    SETTINGS_MAX_ITEMS_PER_LINE = 'WIDGET.SETTINGS_MAX_ITEMS_PER_LINE',
    /**
     * @value In the Next Generation Interface, when possible we display the number of columns as expected. If the widgets' width is too narrow, we use responsiveness to display as many columns as we can.
     * @description An helper to informe the user that the number of columns can change if there is not enough space.
     */
    SETTINGS_MAX_ITEMS_PER_LINE_HELP = 'WIDGET.SETTINGS_MAX_ITEMS_PER_LINE_HELP',
    /**
     * @value Number of elements to display
     */
    SETTINGS_MAX_RESULTS = 'FRONT.SETTINGS.MAX_RESULTS',
    /**
     * @value Limit the number of displayed elements.
     * @description Text used to describe the input Number of element to display in widget settings
     */
    SETTINGS_MAX_RESULTS_HELPER = 'WIDGET_BASE.SETTINGS_MAX_RESULTS_HELPER',
    /**
     * @value This option is not supported with the Next generation interface.
     */
    SETTINGS_OPTION_NOT_SUPPORTED_NGI = 'WIDGET.SETTINGS_OPTION_NOT_SUPPORTED_NGI',
    /**
     * @value Selection type
     */
    SETTINGS_SELECTION_TYPE_TITLE = 'FRONT.SETTINGS.SELECTION_TYPE',
    /**
     * @value Show description
     * @description Text used on widget settings to set whether the description needs to be displayed.
     */
    SETTINGS_SHOW_DESCRIPTION = 'WIDGET_BASE.SETTINGS_SHOW_DESCRIPTION',
    /**
     * @value Load more button
     * @description Text used on widget settings to set whether the load more button needs to be displayed.
     */
    SETTINGS_SHOW_LOAD_MORE = 'WIDGET_BASE.SETTINGS_SHOW_LOAD_MORE',
    /**
     * @value Show search field with filters
     * @description Text used on widget settings to set whether the search needs to be displayed.
     */
    SETTINGS_SHOW_SEARCH = 'WIDGET_BASE.SETTINGS_SHOW_SEARCH',
    /**
     * @value Show separator
     */
    SETTINGS_SHOW_SEPARATOR = 'FRONT.SETTINGS.ITEMS_SEPARATOR',
    /**
     * @value Add a separating lines between each item.
     */
    SETTINGS_SHOW_SEPARATOR_HELPER = 'FRONT.SETTINGS.ITEMS_SEPARATOR_HELP',
    /**
     * @value Variants
     */
    SETTINGS_VARIANTS = 'FRONT.SETTINGS.VIEW_MODE_VARIANTS',
    /**
     * @value Grid
     */
    SETTINGS_VIEW_MODE_GRID = 'FRONT.SETTINGS.VIEW_MODE.GRID',
    /**
     * @value Grouped
     */
    SETTINGS_VIEW_MODE_GROUPED = 'FRONT.SETTINGS.VIEW_MODE_GROUP',
    /**
     * @value List
     */
    SETTINGS_VIEW_MODE_LIST = 'ADMIN.CUSTOMER.STREAMS.VIEW_MODE_LIST',
    /**
     * @value Slideshow
     */
    SETTINGS_VIEW_MODE_SLIDESHOW = 'FRONT.SETTINGS.VIEW_MODE.SLIDESHOW',
    /**
     * @value Ungrouped
     */
    SETTINGS_VIEW_MODE_UNGROUPED = 'FRONT.SETTINGS.VIEW_MODE_UNGROUP',
    /**
     * @value Widget not configured
     * @description Informs the user that a widget has not been configured yet.
     */
    WIDGET_NOT_CONFIGURED = 'WIDGET_MICRO_APP.WIDGET_NOT_CONFIGURED',
}
export const getWidgetTypeTranslationKey = (widgetType: string) =>
    widgetType.toUpperCase() === 'TITLE' ? GLOBAL.TITLE : `WIDGET_TYPE_${widgetType.toUpperCase()}`;
export const getWidgetDescriptionTranslationKey = (widgetType: string) =>
    `WIDGET_TYPE_${widgetType.toUpperCase()}_DESCRIPTION`;
export const getWidgetDeprecationWarningMessage = (widgetType: string) =>
    `FRONT.DEPRECATION_WARNING.SETTINGS.MESSAGE_${widgetType}`;
